import { getInstance } from '../../../lib/axios';
import constants from '../../../constants';

export async function getReleaseNotes() {
  try {
    const url = `${constants.endpoints.RELEASE_NOTES}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch release notes failed', error.message);
    throw error;
  }
}

export async function getAdminReleaseNotes() {
  try {
    const url = `${constants.endpoints.ADMIN_RELEASE_NOTES}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch admin release notes failed', error.message);
    throw error;
  }
}

export async function createAdminReleaseNotes(data) {
  try {
    const response = await getInstance().post(constants.endpoints.ADMIN_RELEASE_NOTES, data);
    return response.data;
  } catch (error) {
    console.error('Create admin release notes failed', error.message);
    throw error;
  }
}